// Hindi strings for the fieldB area (field-facing screens only). Keyed by the English source text; {name} placeholders stay as-is.
// Screens: physical audit walk, first scan walk binding (+ walk exception modal), blind counts (+ RFID import, variance threshold).
export default {
  "(+{count} more)": "(+{count} और)",
  "(Counted: {counted}, Book Stock: {book} on a {par} Par base). Audit Exception {ref} has been flagged for Property Manager investigation.": "(गिना गया: {counted}, बुक स्टॉक: {book}, पार स्तर {par})। ऑडिट अपवाद {ref} को प्रॉपर्टी मैनेजर की जाँच के लिए चिह्नित किया गया है।",
  "(Overdue)": "(अतिदेय)",
  "(default)": "(डिफ़ॉल्ट)",
  "(no reads)": "(कोई रीड नहीं)",
  "(optional)": "(वैकल्पिक)",
  "(set for your organisation)": "(आपके संगठन के लिए तय)",
  "Absent": "अनुपस्थित",
  "Action": "कार्रवाई",
  "Actions": "कार्रवाइयाँ",
  "Active Stock Count & Variance Sessions": "सक्रिय स्टॉक गिनती और अंतर सत्र",
  "Add photo (optional, JPEG, PNG or WebP up to 5 MB)": "फ़ोटो जोड़ें (वैकल्पिक, JPEG, PNG या WebP, 5 MB तक)",
  "Add pooled items to a stock point before logging breakage": "टूट-फूट दर्ज करने से पहले स्टॉक पॉइंट में पूल्ड आइटम जोड़ें",
  "Also read, but not held here: {items}. Transfer them first if they belong to this Stock Point.": "ये भी पढ़े गए, पर यहाँ नहीं रखे हैं: {items}। अगर ये इस स्टॉक पॉइंट के हैं तो पहले इन्हें ट्रांसफ़र करें।",
  "Asset": "एसेट",
  "Asset Item & Tag": "एसेट आइटम और टैग",
  "Asset Lifecycle Status": "एसेट जीवनचक्र स्थिति",
  "Asset tag": "एसेट टैग",
  "Assigned Asset Tag": "असाइन किया गया एसेट टैग",
  "Attach Photo Evidence": "फ़ोटो सबूत लगाएँ",
  "Audit Batch": "ऑडिट बैच",
  "Audit Exception {ref} is now under investigation.": "ऑडिट अपवाद {ref} की अब जाँच चल रही है।",
  "Audit Now": "अभी ऑडिट करें",
  "Audit Type": "ऑडिट प्रकार",
  "Audit Variance Threshold Exceeded (>{pct}% Tolerance Breach)": "ऑडिट अंतर सीमा पार (>{pct}% सहनशीलता उल्लंघन)",
  "Audit Walk": "ऑडिट वॉक",
  "Audit scan {tag}": "ऑडिट स्कैन {tag}",
  "Audit scan {tag} in {room}": "{room} में ऑडिट स्कैन {tag}",
  "Audits": "ऑडिट",
  "BOM: {bom}": "BOM: {bom}",
  "Bind Physical Tag": "भौतिक टैग जोड़ें",
  "Binding Progress": "बाइंडिंग प्रगति",
  "Binding is never blocked.": "बाइंडिंग कभी नहीं रोकी जाती।",
  "Blind Counts": "ब्लाइंड गिनती",
  "Blind Counts & Variance Console": "ब्लाइंड गिनती और अंतर कंसोल",
  "Blind count - {stockPoint} ({count} item)": "ब्लाइंड गिनती - {stockPoint} ({count} आइटम)",
  "Blind count - {stockPoint} ({count} items)": "ब्लाइंड गिनती - {stockPoint} ({count} आइटम)",
  "Blind count submitted successfully ({ref}). All counted items are within the {threshold}% tolerance.": "ब्लाइंड गिनती सफलतापूर्वक जमा हुई ({ref})। सभी गिने गए आइटम {threshold}% सहनशीलता के भीतर हैं।",
  "Book / Counted": "बुक / गिना गया",
  "Book Qty": "बुक मात्रा",
  "Bound": "जुड़ा हुआ",
  "Breakage event {ref} logged and stock decremented by {quantity} units. Total loss: {loss}.": "टूट-फूट घटना {ref} दर्ज हुई और स्टॉक {quantity} यूनिट कम हुआ। कुल नुकसान: {loss}।",
  "Cadence": "शेड्यूल",
  "Cadence Engine": "कैडेंस इंजन",
  "Camera preview": "कैमरा प्रीव्यू",
  "Camera scan failed: {reason}. Enter the 6-character short code instead.": "कैमरा स्कैन विफल: {reason}। इसके बजाय 6 अक्षरों का शॉर्ट कोड डालें।",
  "Camera scanning is not supported on this device. Use a hardware scanner or enter the short code.": "इस डिवाइस पर कैमरा स्कैनिंग समर्थित नहीं है। हार्डवेयर स्कैनर इस्तेमाल करें या शॉर्ट कोड डालें।",
  "Camera unavailable": "कैमरा उपलब्ध नहीं",
  "Camera unavailable ({reason}). Use a handheld scanner or type the code.": "कैमरा उपलब्ध नहीं ({reason})। हैंडहेल्ड स्कैनर इस्तेमाल करें या कोड टाइप करें।",
  "Cancel": "रद्द करें",
  "Category": "श्रेणी",
  "Category: {category} | UoM: {uom}": "श्रेणी: {category} | इकाई: {uom}",
  "Change": "बदलें",
  "Check the file": "फ़ाइल जाँचें",
  "Choose the Stock Point that was read": "वह स्टॉक पॉइंट चुनें जो पढ़ा गया",
  "Choose the reader export file": "रीडर की एक्सपोर्ट फ़ाइल चुनें",
  "Close": "बंद करें",
  "Condition Grade": "स्थिति ग्रेड",
  "Condition of {item}": "{item} की स्थिति",
  "Confirm Tag Binding": "टैग बाइंडिंग पक्की करें",
  "Confirm Write-Off": "राइट-ऑफ़ पक्का करें",
  "Contractor handover": "ठेकेदार हैंडओवर",
  "Could not read the selected photo": "चुनी गई फ़ोटो पढ़ी नहीं जा सकी",
  "Could not read {file}": "{file} पढ़ी नहीं जा सकी",
  "Count a Stock Point from a handheld RFID reader export": "हैंडहेल्ड RFID रीडर के एक्सपोर्ट से स्टॉक पॉइंट गिनें",
  "Count recorded ({ref}):": "गिनती दर्ज हुई ({ref}):",
  "Count sheet saved for offline use on {date}.": "गिनती शीट {date} को ऑफ़लाइन उपयोग के लिए सहेजी गई।",
  "Count with an RFID reader": "RFID रीडर से गिनें",
  "Count {ref} - {item}": "गिनती {ref} - {item}",
  "Counted": "गिना गया",
  "Counted Qty": "गिनी गई मात्रा",
  "Counted at": "गिनती का समय",
  "Counted by": "गिनने वाले",
  "Custody Handover": "कस्टडी हैंडओवर",
  "Cycle Count Batch:": "साइकिल काउंट बैच:",
  "Damage photo attached": "क्षति की फ़ोटो लगी है",
  "Damage photo of {item}": "{item} की क्षति फ़ोटो",
  "Different Model Found": "अलग मॉडल मिला",
  "Different model": "अलग मॉडल",
  "Different model · catalogue review": "अलग मॉडल · कैटलॉग समीक्षा",
  "Different model?": "अलग मॉडल?",
  "Discarded Quantity": "फेंकी गई मात्रा",
  "Due Date": "नियत तारीख",
  "Enter 6-char short code (e.g. {code}) or scan QR code payload.": "6 अक्षरों का शॉर्ट कोड डालें (जैसे {code}) या QR कोड स्कैन करें।",
  "Enter a whole number of at least 1": "कम से कम 1 की पूर्ण संख्या डालें",
  "Enter a whole number, zero or more": "पूर्ण संख्या डालें, शून्य या अधिक",
  "Enter the counted quantity for at least one item": "कम से कम एक आइटम की गिनी गई मात्रा डालें",
  "Enter the make or model you actually found.": "जो मेक या मॉडल वास्तव में मिला वह डालें।",
  "Enter verified count": "सत्यापित गिनती डालें",
  "Every asset in this room already has a tag.": "इस कमरे के हर एसेट पर पहले से टैग है।",
  "Exception": "अपवाद",
  "Exception (>{pct}%)": "अपवाद (>{pct}%)",
  "Exception Status": "अपवाद स्थिति",
  "Execute Blind Count": "ब्लाइंड गिनती करें",
  "Expected Space": "अपेक्षित स्थान",
  "Expected system quantities are hidden from field counter to enforce strict blind count integrity.": "सख़्त ब्लाइंड गिनती के लिए सिस्टम की अपेक्षित मात्रा गिनने वाले से छिपी रहती है।",
  "Export Sheet": "शीट एक्सपोर्ट करें",
  "Extra Item Recorded": "अतिरिक्त आइटम दर्ज हुआ",
  "Extra items found here (not registered)": "यहाँ मिले अतिरिक्त आइटम (पंजीकृत नहीं)",
  "Fair": "ठीक-ठाक",
  "First Scan": "पहला स्कैन",
  "First Scan Walk Active": "पहला स्कैन वॉक सक्रिय",
  "First Scan Walk Binding": "पहला स्कैन वॉक बाइंडिंग",
  "Flag for review": "समीक्षा के लिए चिह्नित करें",
  "Flagged - not moved": "चिह्नित - हटाया नहीं गया",
  "Flagged for Review": "समीक्षा के लिए चिह्नित",
  "Found here": "यहाँ मिला",
  "Found in Another Room": "दूसरे कमरे में मिला",
  "Found in the wrong room": "गलत कमरे में मिला",
  "Found it": "मिल गया",
  "Good": "अच्छी",
  "Highlights the next expected item. Nothing is recorded until you scan or tick it.": "अगले अपेक्षित आइटम को दिखाता है। स्कैन या टिक करने तक कुछ दर्ज नहीं होता।",
  "Import RFID Reads": "RFID रीड आयात करें",
  "Investigate": "जाँच करें",
  "Item": "आइटम",
  "Item Absent": "आइटम अनुपस्थित",
  "Item Blueprint": "आइटम ब्लूप्रिंट",
  "Item Name": "आइटम का नाम",
  "Item absent": "आइटम अनुपस्थित",
  "Item to Count: {item}": "गिनने का आइटम: {item}",
  "Item {item}": "आइटम {item}",
  "Kit expected {model}": "किट में अपेक्षित {model}",
  "Launch Walk": "वॉक शुरू करें",
  "Load Room": "कमरा लोड करें",
  "Loading checklist…": "चेकलिस्ट लोड हो रही है…",
  "Loading count sessions...": "गिनती सत्र लोड हो रहे हैं...",
  "Loading scheduled audit tasks...": "निर्धारित ऑडिट कार्य लोड हो रहे हैं...",
  "Located in {room}": "{room} में मौजूद",
  "Location": "स्थान",
  "Log Breakage Event": "टूट-फूट दर्ज करें",
  "Log Point of Event Breakage": "घटना स्थल पर टूट-फूट दर्ज करें",
  "Loss exceeds {limit}: an approval task was routed to the Department Head.": "नुकसान {limit} से अधिक है: मंज़ूरी का कार्य विभाग प्रमुख को भेजा गया।",
  "Make found": "मिला मेक",
  "Manage Schedules & Coverage": "शेड्यूल और कवरेज प्रबंधित करें",
  "Manufacturer Serial #": "निर्माता सीरियल #",
  "Manufacturer Serial Number": "निर्माता सीरियल नंबर",
  "Mark Absent": "अनुपस्थित चिह्नित करें",
  "Missing": "गायब",
  "Model found": "मिला मॉडल",
  "Move Not Recorded": "स्थानांतरण दर्ज नहीं हुआ",
  "Move here": "यहाँ ले आएँ",
  "Move here needs a connection; the item stays flagged until then.": "यहाँ ले आने के लिए कनेक्शन चाहिए; तब तक आइटम चिह्नित रहेगा।",
  "Moved Here": "यहाँ लाया गया",
  "Moved here": "यहाँ लाया गया",
  "My Scheduled Audit Tasks": "मेरे निर्धारित ऑडिट कार्य",
  "My Scheduled Audits": "मेरे निर्धारित ऑडिट",
  "Next": "अगला",
  "Next expected: {name} ({code}). Find it, then scan or tick it.": "अगला अपेक्षित: {name} ({code})। इसे ढूँढें, फिर स्कैन या टिक करें।",
  "No assets are registered to this space.": "इस स्थान पर कोई एसेट पंजीकृत नहीं है।",
  "No blind counts recorded yet.": "अभी तक कोई ब्लाइंड गिनती दर्ज नहीं हुई।",
  "No blind counts recorded yet. Set up a stock point first, then start a blind count.": "अभी तक कोई ब्लाइंड गिनती दर्ज नहीं हुई। पहले स्टॉक पॉइंट बनाएँ, फिर ब्लाइंड गिनती शुरू करें।",
  "No floor": "कोई मंज़िल नहीं",
  "No open audit batches": "कोई खुला ऑडिट बैच नहीं",
  "No overdue audit tasks.": "कोई अतिदेय ऑडिट कार्य नहीं।",
  "No pooled items are held at this stock point.": "इस स्टॉक पॉइंट पर कोई पूल्ड आइटम नहीं है।",
  "No property is loaded yet": "अभी कोई प्रॉपर्टी लोड नहीं हुई",
  "No room selected.": "कोई कमरा नहीं चुना गया।",
  "No rooms have been stamped with a Room Kit yet. Stamp a kit to a room, then start the walk.": "अभी तक किसी कमरे पर रूम किट स्टैम्प नहीं हुई। किसी कमरे पर किट स्टैम्प करें, फिर वॉक शुरू करें।",
  "No scheduled audit tasks are assigned to you.": "आपको कोई निर्धारित ऑडिट कार्य नहीं सौंपा गया है।",
  "No stamped rooms.": "कोई स्टैम्प किया कमरा नहीं।",
  "No stock points yet — set one up in": "अभी कोई स्टॉक पॉइंट नहीं — इसे यहाँ बनाएँ:",
  "None": "कोई नहीं",
  "None of the chips belong to an item held at this Stock Point. A storekeeper maps chips to items on the Stock Points screen.": "कोई भी चिप इस स्टॉक पॉइंट के किसी आइटम की नहीं है। स्टोरकीपर स्टॉक पॉइंट स्क्रीन पर चिप को आइटम से जोड़ता है।",
  "Not recorded": "दर्ज नहीं",
  "Note": "नोट",
  "Nothing has been moved yet.": "अभी तक कुछ नहीं हटाया गया।",
  "Offline": "ऑफ़लाइन",
  "Offline Mode": "ऑफ़लाइन मोड",
  "Offline Scans Synced": "ऑफ़लाइन स्कैन सिंक हुए",
  "Offline: tag {tag} for {asset} is saved on this device and is bound when you are back online.": "ऑफ़लाइन: {asset} का टैग {tag} इस डिवाइस पर सहेजा गया है और ऑनलाइन होने पर जुड़ जाएगा।",
  "Onboarding walk console: scan physical room barcodes, inspect template-stamped draft assets, and bind physical QR tags to activate fixed assets.": "ऑनबोर्डिंग वॉक कंसोल: कमरे के बारकोड स्कैन करें, टेम्पलेट से बने ड्राफ़्ट एसेट जाँचें, और फ़िक्स्ड एसेट सक्रिय करने के लिए QR टैग जोड़ें।",
  "Open a room by scanning its tag, then scan or tick every expected item with its condition. Items found in the wrong room are never moved without your choice.": "कमरे का टैग स्कैन करके उसे खोलें, फिर हर अपेक्षित आइटम को उसकी स्थिति के साथ स्कैन या टिक करें। गलत कमरे में मिले आइटम आपकी मर्ज़ी के बिना कभी नहीं हटाए जाते।",
  "Open a room first: scan its tag or type its code.": "पहले कमरा खोलें: उसका टैग स्कैन करें या कोड टाइप करें।",
  "Open room": "कमरा खोलें",
  "Or pick the room:": "या कमरा चुनें:",
  "Or select a stamped room from the walk list": "या वॉक सूची से स्टैम्प किया कमरा चुनें",
  "Outlet Audit": "आउटलेट ऑडिट",
  "Overdue audits are escalated to the schedule's Department Head.": "अतिदेय ऑडिट शेड्यूल के विभाग प्रमुख को भेजे जाते हैं।",
  "Owner handover": "मालिक हैंडओवर",
  "Page {page} - {total} counted lines": "पृष्ठ {page} - {total} गिनी गई पंक्तियाँ",
  "Par Level": "पार स्तर",
  "Pending Scan": "स्कैन बाकी",
  "Pending Tasks": "लंबित कार्य",
  "Photo": "फ़ोटो",
  "Photos must be JPEG, PNG or WebP images": "फ़ोटो JPEG, PNG या WebP होनी चाहिए",
  "Photos must be JPEG, PNG or WebP images.": "फ़ोटो JPEG, PNG या WebP होनी चाहिए।",
  "Photos need a connection, so it was saved without one.": "फ़ोटो के लिए कनेक्शन चाहिए, इसलिए इसे बिना फ़ोटो सहेजा गया।",
  "Photos need a connection. While offline the item is saved as damaged without a photo.": "फ़ोटो के लिए कनेक्शन चाहिए। ऑफ़लाइन होने पर आइटम बिना फ़ोटो के क्षतिग्रस्त के रूप में सहेजा जाता है।",
  "Physical Audit": "भौतिक ऑडिट",
  "Physical Audit Verification & Schedules": "भौतिक ऑडिट सत्यापन और शेड्यूल",
  "Physical Condition": "भौतिक स्थिति",
  "Physically Counted Quantity": "वास्तव में गिनी गई मात्रा",
  "Point camera or scan tag": "कैमरा दिखाएँ या टैग स्कैन करें",
  "Pooled Item Name": "पूल्ड आइटम का नाम",
  "Poor": "खराब",
  "Previous": "पिछला",
  "Progress:": "प्रगति:",
  "Property": "प्रॉपर्टी",
  "RFID count {ref} submitted for {stockPoint}: {lines} item(s) from {chips} chips, {exceptions} over the variance threshold.": "{stockPoint} के लिए RFID गिनती {ref} जमा हुई: {chips} चिप से {lines} आइटम, {exceptions} अंतर सीमा से ऊपर।",
  "RFID count {ref} submitted for {stockPoint}: {lines} item(s) from {chips} chips.": "{stockPoint} के लिए RFID गिनती {ref} जमा हुई: {chips} चिप से {lines} आइटम।",
  "Reader export (CSV or text)": "रीडर एक्सपोर्ट (CSV या टेक्स्ट)",
  "Reason Code": "कारण कोड",
  "Recent count session in": "हाल का गिनती सत्र",
  "Record": "दर्ज करें",
  "Record Model": "मॉडल दर्ज करें",
  "Record {item} as damaged": "{item} को क्षतिग्रस्त दर्ज करें",
  "Remove": "हटाएँ",
  "Review": "देखें",
  "Room": "कमरा",
  "Room Audit": "कमरा ऑडिट",
  "Room Door Code (QR / Barcode / Room Number)": "कमरे के दरवाज़े का कोड (QR / बारकोड / कमरा नंबर)",
  "Room Opened": "कमरा खुला",
  "Room Signed Off": "कमरा साइन-ऑफ़ हुआ",
  "Room kit": "रूम किट",
  "Room sign-off - {room}": "कमरा साइन-ऑफ़ - {room}",
  "Rooms assigned to you by recurring audit schedules. Launch a walk to verify a room; signing it off completes the task.": "आवर्ती ऑडिट शेड्यूल से आपको सौंपे गए कमरे। कमरा जाँचने के लिए वॉक शुरू करें; साइन-ऑफ़ करने पर कार्य पूरा होता है।",
  "Run blind stock counts, flag variances above {threshold}% and log breakage.": "ब्लाइंड स्टॉक गिनती करें, {threshold}% से अधिक अंतर चिह्नित करें और टूट-फूट दर्ज करें।",
  "Save": "सहेजें",
  "Save as Damaged": "क्षतिग्रस्त के रूप में सहेजें",
  "Saved Offline": "ऑफ़लाइन सहेजा गया",
  "Saving...": "सहेजा जा रहा है...",
  "Scan & Bind": "स्कैन करें और जोड़ें",
  "Scan Items": "आइटम स्कैन करें",
  "Scan Not Recorded": "स्कैन दर्ज नहीं हुआ",
  "Scan Physical QR Tag (ULID / Short Code)": "भौतिक QR टैग स्कैन करें (ULID / शॉर्ट कोड)",
  "Scan Room Code": "कमरा कोड स्कैन करें",
  "Scan a room code or select a stamped room to start the walk.": "वॉक शुरू करने के लिए कमरा कोड स्कैन करें या स्टैम्प किया कमरा चुनें।",
  "Scan an item from elsewhere": "कहीं और का आइटम स्कैन करें",
  "Scan an item tag, or tick an item on the checklist": "आइटम टैग स्कैन करें, या चेकलिस्ट में आइटम टिक करें",
  "Scan or enter a room code": "कमरा कोड स्कैन करें या डालें",
  "Scan or enter the physical tag": "भौतिक टैग स्कैन करें या डालें",
  "Scan or select a room first to bind its tags.": "टैग जोड़ने के लिए पहले कमरा स्कैन करें या चुनें।",
  "Scan or type the item tag or short code": "आइटम टैग या शॉर्ट कोड स्कैन करें या टाइप करें",
  "Scan the tag of an item that is here but belongs to another room": "उस आइटम का टैग स्कैन करें जो यहाँ है पर दूसरे कमरे का है",
  "Scan with a handheld scanner into the field below, use the camera, or type the short code printed under the tag.": "नीचे के फ़ील्ड में हैंडहेल्ड स्कैनर से स्कैन करें, कैमरा इस्तेमाल करें, या टैग के नीचे छपा शॉर्ट कोड टाइप करें।",
  "Scan with camera": "कैमरे से स्कैन करें",
  "Schedule": "शेड्यूल",
  "Select Start Blind Count to begin.": "शुरू करने के लिए 'ब्लाइंड गिनती शुरू करें' चुनें।",
  "Select Stock Point": "स्टॉक पॉइंट चुनें",
  "Select an audit batch and a room to load its checklist.": "चेकलिस्ट लोड करने के लिए ऑडिट बैच और कमरा चुनें।",
  "Select an audit batch and room to sign off": "साइन-ऑफ़ के लिए ऑडिट बैच और कमरा चुनें",
  "Select an item": "आइटम चुनें",
  "Select the draft asset to bind": "जोड़ने के लिए ड्राफ़्ट एसेट चुनें",
  "Serialized Asset Checklist": "सीरियल एसेट चेकलिस्ट",
  "Session Ref": "सत्र संदर्भ",
  "Set up a stock point first": "पहले स्टॉक पॉइंट बनाएँ",
  "Shift handover": "शिफ़्ट हैंडओवर",
  "Show next expected": "अगला अपेक्षित दिखाएँ",
  "Showing the checklist saved for offline use on {date}. Results sync when you are back online.": "{date} को ऑफ़लाइन उपयोग के लिए सहेजी गई चेकलिस्ट दिख रही है। ऑनलाइन होने पर परिणाम सिंक होंगे।",
  "Showing the checklist saved for offline use. Results sync when you are back online.": "ऑफ़लाइन उपयोग के लिए सहेजी गई चेकलिस्ट दिख रही है। ऑनलाइन होने पर परिणाम सिंक होंगे।",
  "Sign off with items missing": "गायब आइटम के साथ साइन-ऑफ़ करें",
  "Sign off {room}": "{room} साइन-ऑफ़ करें",
  "Sign-Off Failed": "साइन-ऑफ़ विफल",
  "Sign-Off Queued": "साइन-ऑफ़ कतार में",
  "Sign-Off {room}": "{room} साइन-ऑफ़ करें",
  "Skipped lines: {lines}": "छोड़ी गई पंक्तियाँ: {lines}",
  "Spot Check": "स्पॉट चेक",
  "Stamped Assets Awaiting Tag Binding": "टैग जोड़ने की प्रतीक्षा में स्टैम्प किए एसेट",
  "Stamped Kit Active": "स्टैम्प की गई किट सक्रिय",
  "Stamped Template:": "स्टैम्प किया टेम्पलेट:",
  "Stamped from Room Kit": "रूम किट से स्टैम्प किया",
  "Start Blind Count": "ब्लाइंड गिनती शुरू करें",
  "Start here: scan the room's tag or type its code": "यहाँ से शुरू करें: कमरे का टैग स्कैन करें या उसका कोड टाइप करें",
  "Status": "स्थिति",
  "Stock Point Location": "स्टॉक पॉइंट स्थान",
  "Stock Point that was read": "पढ़ा गया स्टॉक पॉइंट",
  "Stock Points & Par Management": "स्टॉक पॉइंट और पार प्रबंधन",
  "Stock point": "स्टॉक पॉइंट",
  "Stop camera": "कैमरा बंद करें",
  "Store Audit": "स्टोर ऑडिट",
  "Submit Counted Quantities": "गिनी गई मात्राएँ जमा करें",
  "Submit as blind count": "ब्लाइंड गिनती के रूप में जमा करें",
  "Submitting...": "जमा हो रहा है...",
  "Sweep the Stock Point with the handheld reader, export the reads as CSV (one EPC per row; antenna and time columns are optional) and choose the file. Each RFID chip is counted once, however often it was read.": "हैंडहेल्ड रीडर से स्टॉक पॉइंट स्कैन करें, रीड को CSV में एक्सपोर्ट करें (हर पंक्ति में एक EPC; एंटेना और समय कॉलम वैकल्पिक) और फ़ाइल चुनें। हर RFID चिप एक बार गिनी जाती है, चाहे जितनी बार पढ़ी गई हो।",
  "Sync Completed With Issues": "सिंक पूरा हुआ, कुछ समस्याएँ हैं",
  "Sync status": "सिंक स्थिति",
  "Syncing": "सिंक हो रहा है",
  "Tag {tag} bound to {asset}. The asset is now in_service.": "टैग {tag} {asset} से जुड़ा। एसेट अब सेवा में है।",
  "Tag {tag} is not registered at this property. It was recorded as an Extra item in {room} ({ref}) for a manager to resolve.": "टैग {tag} इस प्रॉपर्टी में पंजीकृत नहीं है। इसे {room} में अतिरिक्त आइटम ({ref}) के रूप में दर्ज किया गया, मैनेजर इसे सुलझाएगा।",
  "Tag {tag} queued and will be checked when you are back online (it may belong to another room or be an extra item).": "टैग {tag} कतार में है और ऑनलाइन होने पर जाँचा जाएगा (यह दूसरे कमरे का या अतिरिक्त आइटम हो सकता है)।",
  "Tag {tag} to {asset}": "टैग {tag} → {asset}",
  "Tag {tag} to {asset} in {room}": "टैग {tag} → {asset}, {room} में",
  "Tag: {tag}": "टैग: {tag}",
  "Tap NFC tag": "NFC टैग टैप करें",
  "Tap item NFC tag": "आइटम का NFC टैग टैप करें",
  "Tap room NFC tag": "कमरे का NFC टैग टैप करें",
  "Tap the Stock Point's NFC tag": "स्टॉक पॉइंट का NFC टैग टैप करें",
  "Target Draft Asset": "लक्ष्य ड्राफ़्ट एसेट",
  "That tag is not on a Stock Point of this property": "यह टैग इस प्रॉपर्टी के किसी स्टॉक पॉइंट पर नहीं है",
  "The file is larger than 8 MB. Export a smaller batch of reads from the reader.": "फ़ाइल 8 MB से बड़ी है। रीडर से रीड का छोटा बैच एक्सपोर्ट करें।",
  "The item is a different make or model than the kit lists (record it after binding)": "आइटम किट में लिखे मेक या मॉडल से अलग है (जोड़ने के बाद दर्ज करें)",
  "The item is here but is another make or model than the kit lists. The asset records what you found and the line is flagged for catalogue review. Bind its tag as usual.": "आइटम यहाँ है पर किट में लिखे से अलग मेक या मॉडल का है। एसेट में आपको जो मिला वह दर्ज होगा और लाइन कैटलॉग समीक्षा के लिए चिह्नित होगी। टैग हमेशा की तरह जोड़ें।",
  "The item is not in the room. It stays unbound and is flagged as missing so it can be followed up; nothing is deleted. If it turns up later, choose “Found it” and bind its tag.": "आइटम कमरे में नहीं है। यह बिना जुड़ा रहेगा और गायब के रूप में चिह्नित होगा ताकि आगे देखा जा सके; कुछ नहीं हटाया जाता। बाद में मिल जाए तो “मिल गया” चुनें और टैग जोड़ें।",
  "The whole Stock Point was swept: count items with no reads as 0": "पूरा स्टॉक पॉइंट स्कैन हुआ: बिना रीड वाले आइटम 0 गिनें",
  "There are no open audit batches. An audit batch is opened from Audit Schedules (or by an auditor) before a walk can start.": "कोई खुला ऑडिट बैच नहीं है। वॉक शुरू करने से पहले ऑडिट शेड्यूल से (या ऑडिटर द्वारा) ऑडिट बैच खोला जाता है।",
  "This browser cannot read tags with the camera. Use a handheld scanner or type the code printed under the tag.": "यह ब्राउज़र कैमरे से टैग नहीं पढ़ सकता। हैंडहेल्ड स्कैनर इस्तेमाल करें या टैग के नीचे छपा कोड टाइप करें।",
  "This room has no stamped assets to bind.": "इस कमरे में जोड़ने के लिए कोई स्टैम्प किया एसेट नहीं है।",
  "This room has no stamped assets.": "इस कमरे में कोई स्टैम्प किया एसेट नहीं है।",
  "Tick as present with the condition shown": "दिखाई गई स्थिति के साथ मौजूद के रूप में टिक करें",
  "Tick {item} as present": "{item} को मौजूद के रूप में टिक करें",
  "Toggle Sound Feedback": "ध्वनि संकेत चालू/बंद करें",
  "Toggle sound feedback": "ध्वनि संकेत चालू/बंद करें",
  "Tolerance: {pct}%": "सहनशीलता: {pct}%",
  "Total Write-Off Loss Amount:": "कुल राइट-ऑफ़ नुकसान राशि:",
  "Unbound Draft": "बिना जुड़ा ड्राफ़्ट",
  "Unknown": "अज्ञात",
  "Upgrading to {plan} covers them. Binding is never blocked.": "{plan} पर अपग्रेड करने से ये कवर होंगे। बाइंडिंग कभी नहीं रोकी जाती।",
  "Use camera": "कैमरा इस्तेमाल करें",
  "Variance": "अंतर",
  "Variance %": "अंतर %",
  "Variance rule: >{pct}% of book stock": "अंतर नियम: बुक स्टॉक का >{pct}%",
  "Variance threshold (%)": "अंतर सीमा (%)",
  "Variance threshold:": "अंतर सीमा:",
  "Verified": "सत्यापित",
  "Verified (queued)": "सत्यापित (कतार में)",
  "Verified (ticked)": "सत्यापित (टिक किया)",
  "Verified Successfully!": "सफलतापूर्वक सत्यापित!",
  "View": "देखें",
  "Walk": "वॉक",
  "Within Par": "पार के भीतर",
  "You are offline and audits were not prepared for offline use on this device.": "आप ऑफ़लाइन हैं और इस डिवाइस पर ऑडिट ऑफ़लाइन उपयोग के लिए तैयार नहीं किए गए।",
  "You are offline and this room code is not in the rooms prepared for offline use.": "आप ऑफ़लाइन हैं और यह कमरा कोड ऑफ़लाइन के लिए तैयार कमरों में नहीं है।",
  "You are offline and this room was not prepared for offline use. Use Prepare for offline on the Sync status page before the walk.": "आप ऑफ़लाइन हैं और यह कमरा ऑफ़लाइन के लिए तैयार नहीं किया गया। वॉक से पहले सिंक स्थिति पेज पर 'ऑफ़लाइन के लिए तैयार करें' इस्तेमाल करें।",
  "You are offline and this space was not prepared for offline use, so its checklist is not available. Scans are queued and checked on reconnection. Use Prepare for offline on the Sync status page before a shift.": "आप ऑफ़लाइन हैं और यह स्थान ऑफ़लाइन के लिए तैयार नहीं किया गया, इसलिए इसकी चेकलिस्ट उपलब्ध नहीं है। स्कैन कतार में रहते हैं और कनेक्शन लौटने पर जाँचे जाते हैं। शिफ़्ट से पहले सिंक स्थिति पेज पर 'ऑफ़लाइन के लिए तैयार करें' इस्तेमाल करें।",
  "You are offline and this stock point was not prepared for offline use. Use Prepare for offline on the Sync status page before counting offline.": "आप ऑफ़लाइन हैं और यह स्टॉक पॉइंट ऑफ़लाइन के लिए तैयार नहीं किया गया। ऑफ़लाइन गिनती से पहले सिंक स्थिति पेज पर 'ऑफ़लाइन के लिए तैयार करें' इस्तेमाल करें।",
  "You are offline: the count for {stockPoint} is saved on this device and will be submitted automatically when you are back online.": "आप ऑफ़लाइन हैं: {stockPoint} की गिनती इस डिवाइस पर सहेजी गई है और ऑनलाइन होने पर अपने-आप जमा हो जाएगी।",
  "Your plan covers {limit} tagged assets and {used} are now tagged.": "आपका प्लान {limit} टैग किए एसेट कवर करता है और अब {used} टैग हो चुके हैं।",
  "another model": "दूसरा मॉडल",
  "belongs to {room} but was scanned in": "{room} का है पर स्कैन हुआ",
  "closed": "बंद",
  "counts are saved on this device and submitted when you are back online": "गिनतियाँ इस डिवाइस पर सहेजी जाती हैं और ऑनलाइन होने पर जमा होती हैं",
  "detected a": "में पाया गया",
  "distinct chips": "अलग-अलग चिप",
  "draft": "ड्राफ़्ट",
  "e.g. {code}": "जैसे {code}",
  "e.g. {code} or {number}": "जैसे {code} या {number}",
  "fair": "ठीक-ठाक",
  "good": "अच्छी",
  "in_service": "सेवा में",
  "kit expects {model}": "किट में अपेक्षित {model}",
  "n/a": "लागू नहीं",
  "not mapped to an item": "किसी आइटम से जुड़ी नहीं",
  "on": "पर",
  "pending investigation": "जाँच लंबित",
  "poor": "खराब",
  "reads": "रीड",
  "resolved": "सुलझाया गया",
  "room": "कमरा",
  "stock point": "स्टॉक पॉइंट",
  "tags you bind are saved on this device and synced when you are back online": "आप जो टैग जोड़ते हैं वे इस डिवाइस पर सहेजे जाते हैं और ऑनलाइन होने पर सिंक होते हैं",
  "this stock point": "इस स्टॉक पॉइंट",
  "to start counting.": "ताकि गिनती शुरू हो सके।",
  "under investigation": "जाँच जारी",
  "where it had been flagged missing": "जहाँ इसे गायब चिह्नित किया गया था",
  "{applied} queued transaction synced, {failed} need your attention on the Sync status page.": "{applied} कतारबद्ध लेनदेन सिंक हुआ, {failed} पर सिंक स्थिति पेज पर ध्यान देना है।",
  "{applied} queued transaction synced.": "{applied} कतारबद्ध लेनदेन सिंक हुआ।",
  "{applied} queued transactions synced, {failed} need your attention on the Sync status page.": "{applied} कतारबद्ध लेनदेन सिंक हुए, {failed} पर सिंक स्थिति पेज पर ध्यान देना है।",
  "{applied} queued transactions synced.": "{applied} कतारबद्ध लेनदेन सिंक हुए।",
  "{asset} found. Bind its tag now.": "{asset} मिल गया। अब इसका टैग जोड़ें।",
  "{asset} marked absent. It stays unbound and is flagged as missing.": "{asset} अनुपस्थित चिह्नित हुआ। यह बिना जुड़ा रहेगा और गायब के रूप में चिह्नित है।",
  "{asset} stays registered to {room}; a manager reviews the relocation in the exception queue.": "{asset} {room} में ही पंजीकृत रहेगा; मैनेजर अपवाद कतार में स्थानांतरण की समीक्षा करेगा।",
  "{asset}: actual make/model recorded and flagged for catalogue review.": "{asset}: असली मेक/मॉडल दर्ज हुआ और कैटलॉग समीक्षा के लिए चिह्नित किया गया।",
  "{asset}: saved on this device while offline. It is recorded when you are back online.": "{asset}: ऑफ़लाइन रहते हुए इस डिवाइस पर सहेजा गया। ऑनलाइन होने पर दर्ज होगा।",
  "{bound} / {total} Tagged Bound": "{bound} / {total} टैग जुड़े",
  "{count} Overdue Audit Task:": "{count} अतिदेय ऑडिट कार्य:",
  "{count} Overdue Audit Tasks:": "{count} अतिदेय ऑडिट कार्य:",
  "{count} absent": "{count} अनुपस्थित",
  "{count} binding waiting to sync": "{count} बाइंडिंग सिंक की प्रतीक्षा में",
  "{count} bindings waiting to sync": "{count} बाइंडिंग सिंक की प्रतीक्षा में",
  "{count} count waiting to be submitted": "{count} गिनती जमा होने की प्रतीक्षा में",
  "{count} counts waiting to be submitted": "{count} गिनतियाँ जमा होने की प्रतीक्षा में",
  "{count} different model": "{count} अलग मॉडल",
  "{count} offline action needs your attention: the record changed before it could be synced.": "{count} ऑफ़लाइन कार्रवाई पर ध्यान देना है: सिंक होने से पहले रिकॉर्ड बदल गया।",
  "{count} offline actions need your attention: the record changed before it could be synced.": "{count} ऑफ़लाइन कार्रवाइयों पर ध्यान देना है: सिंक होने से पहले रिकॉर्ड बदल गया।",
  "{count} other action": "{count} अन्य कार्रवाई",
  "{count} other actions": "{count} अन्य कार्रवाइयाँ",
  "{count} sign-off": "{count} साइन-ऑफ़",
  "{file} is larger than 5 MB.": "{file} 5 MB से बड़ी है।",
  "{item} variance is {variance} units ({pct}). Exceeds {threshold}% par threshold: Audit Exception #{ref} created ({status}).": "{item} का अंतर {variance} यूनिट ({pct}) है। {threshold}% पार सीमा से अधिक: ऑडिट अपवाद #{ref} बना ({status})।",
  "{location} was due on": "{location} की नियत तारीख थी",
  "{mode} - {count} scan queued locally": "{mode} - {count} स्कैन डिवाइस पर कतार में",
  "{mode} - {count} scans queued locally": "{mode} - {count} स्कैन डिवाइस पर कतार में",
  "{pct} variance": "{pct} अंतर",
  "{ref} - waiting for a manager in the exception queue": "{ref} - अपवाद कतार में मैनेजर की प्रतीक्षा",
  "{room} Stamped Assets Awaiting Tag Binding": "{room} के स्टैम्प किए एसेट टैग जोड़ने की प्रतीक्षा में",
  "{room} inspection signed off: {verified} verified, {missing} missing, {mislocated} mislocated. Room compliance {pct}%.": "{room} निरीक्षण साइन-ऑफ़ हुआ: {verified} सत्यापित, {missing} गायब, {mislocated} गलत जगह। कमरा अनुपालन {pct}%।",
  "{room} is open. Scan or tick each expected item.": "{room} खुला है। हर अपेक्षित आइटम स्कैन या टिक करें।",
  "{room} loaded - {count} draft asset(s) awaiting a tag.": "{room} लोड हुआ - {count} ड्राफ़्ट एसेट टैग की प्रतीक्षा में।",
  "{room} sign-off will be committed when the connection returns.": "कनेक्शन लौटने पर {room} का साइन-ऑफ़ दर्ज होगा।",
  "{tagged} Tagged Assets, {pooled} Pooled Lines": "{tagged} टैग किए एसेट, {pooled} पूल्ड लाइनें",
  "{tag} belongs to {location}. It has not been moved: choose Move here or Flag for review.": "{tag} {location} का है। इसे हटाया नहीं गया: 'यहाँ ले आएँ' या 'समीक्षा के लिए चिह्नित करें' चुनें।",
  "{tag} marked verified in {room} as damaged with a photo.": "{tag} {room} में फ़ोटो सहित क्षतिग्रस्त के रूप में सत्यापित हुआ।",
  "{tag} marked verified in {room} as damaged.": "{tag} {room} में क्षतिग्रस्त के रूप में सत्यापित हुआ।",
  "{tag} marked verified in {room}.": "{tag} {room} में सत्यापित हुआ।",
  "{tag} now belongs to {to} (moved from {from}).": "{tag} अब {to} का है ({from} से लाया गया)।",
  "{tag} now belongs to {to}.": "{tag} अब {to} का है।",
  "{tag} verified locally and queued for sync.": "{tag} डिवाइस पर सत्यापित हुआ और सिंक के लिए कतार में है।",
  "{verified} of {expected} ({pct}%)": "{expected} में से {verified} ({pct}%)",
  "{verified} of {expected} Assets Verified ({pct}%)": "{expected} में से {verified} एसेट सत्यापित ({pct}%)",
};
